import type { HoldingNodeType } from 'app-components/flux/investment-holdings-v2';

import type { AiChatConversationContext } from '../aiChatContextTypes';

type BuildInvestmentHoldingAiContextArgs = {
  holding: HoldingNodeType;
  displayName?: string;
};

export const buildInvestmentHoldingAiContext = ({
  holding,
  displayName,
}: BuildInvestmentHoldingAiContextArgs): AiChatConversationContext => ({
  label: 'Current investment holding',
  data: {
    symbol: holding.symbol,
    name: displayName ?? holding.name,
  },
});
